<section class="flex-layout-column">
  <mat-card
    class="flex-100 product-card"
    [routerLink]="product.id + '/' + urlName(product)"
  >
    <mat-card-content
      class="flex-layout-row flex-layout-column-lt-sm flex-layout-align-start-stretch-lt-sm"
    >
      <div class="flex-layout-column flex-35 flex-50-lt-md">
        <div class="flex-layout-column flex-100">
          <span class="product-label">{{ product.vendor }}</span>
          <span class="product-title">{{ product.name }}</span>
        </div>
        <div
          *ngIf="currentUser && !product.available"
          class="product-alert-info flex-layout-row flex-layout-align-start-center flex-100 display-none-lt-sm"
          fxLayoutGap="15px"
        >
          <mat-icon
            (click)="createProductNotification($event)"
            class="blue flex-layout-align-start-center"
            [ngClass]="{
              'material-icons-outlined':
                product.product_notification_state === null
            }"
            >notifications</mat-icon
          >
          <div
            *ngIf="product['product_notification_state'] === null"
            class="flex-90"
          >
            {{ 'marketplace.add_alert' | translate }}
            <span class="text-nowrap"
              >{{ 'footer.contact_phone' | translate }}</span
            >
          </div>
          <div
            *ngIf="product['product_notification_state'] !== null"
            class="flex-90"
          >
            {{ 'marketplace.alert_created' | translate }}
          </div>
        </div>
      </div>
      <div class="flex-layout-column display-none-lt-md flex-20">
        <ng-container
          *ngIf="
            (product.vendor_price && discount > 0) || (price && discount > 0)
          "
        >
          <div class="flex-layout-row">
            <span class="product-label flex-60">{{ priceText }}</span>
            <span class="product-label text-right flex-40">
              {{ price | pricify }}
            </span>
          </div>
          <div
            class="flex-layout-row"
            *ngIf="
            (product.vendor_price && discount > 0) || (price && discount > 0)
          "
          >
            <span class="product-label green flex-60">
              {{ 'marketplace.save_label' | translate }}
            </span>
            <span class="product-label green text-right flex-40">
              {{ discount | pricify }}
            </span>
          </div>
        </ng-container>
      </div>
      <mat-divider
        class="flex-layout-column display-none-lt-sm me-3x flex-auto"
        [vertical]="true"
      ></mat-divider>
      <div
        class="flex-layout-column flex-layout-align-start-end flex-layout-row-lt-sm flex-layout-align-start-center-lt-sm flex-18 flex-100-lt-sm"
      >
        <p class="product-label flex-50-lt-sm">
          {{ 'marketplace.price_label' | translate }}
        </p>
        <p class="product-price flex-50-lt-sm">
          {{ discountedPrice | pricify }}
        </p>
      </div>
      <div
        class="flex-layout-column flex-layout-align-space-around-none ps-5x ps-0x-lt-sm flex-25 flex-100-lt-sm"
        *ngIf="product.available"
      >
        <button
          mat-raised-button
          [disabled]="buttonClicked"
          name="add-to-basket"
          class="global-btn-blue medium-font"
          (click)="addToCartDialog($event)"
        >
          + {{ 'marketplace.add_button' | translate }}
        </button>
        <app-add-project-item
          *ngIf="loggedIn | async"
          class="add-to-project"
          [productItem]="product"
          [projects]="projects"
          [buttonClicked]="buttonClicked"
          [(open)]="isProjectInputOpen"
          (click)="openProjectList($event)"
        ></app-add-project-item>
      </div>
      <div
        class="notAvailable buttons-container flex-layout-column flex-layout-align-space-around-none ps-5x ps-0x-lt-sm flex-25 flex-100-lt-sm"
        *ngIf="!product.available"
      >
        <button
          mat-raised-button
          class="global-btn-blue"
          style="z-index: 100000"
          disabled
        >
          + {{ 'marketplace.add_button' | translate }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</section>
